import { render, staticRenderFns } from "./tjDetail.vue?vue&type=template&id=3124f059&"
import script from "./tjDetail.vue?vue&type=script&lang=js&"
export * from "./tjDetail.vue?vue&type=script&lang=js&"
import style0 from "./tjDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports